<template>
  <b-form-group
    :label="title"
    :label-for="id"
    :description="description"
    label-cols-sm="3"
  >
    <b-form-datepicker :id="id" v-model="value"
      today-button
      :reset-button="!required"
      close-button
      locale="ja"
      :state="getState()"
      :required="required"
      label-today-button="今日を指定"
      label-reset-button="指定しない"
      label-close-button="閉じる"
      :label-no-date-selected="placeholder"
      :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
      @input="changed">
    </b-form-datepicker>
    <div v-if="required && !value" class="text-danger">この項目は入力必須です</div>
    <slot>
    <!-- 他に表示する要素があればここに入る -->
    </slot>
  </b-form-group>
</template>

<script>
export default {
  name: 'ElementDatePicker',
  props: {
    title: String,
    id: String,
    description: {
      type: String,
      default: ''
    },
    vModel: {
      type: Date,
      default: null
    },
    placeholder: {
      type: String,
      default: '指定していません'
    },
    state: {
      type: Boolean,
      default: true
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      value: this.vModel
    }
  },
  methods: {
    changed: function () {
      var date = null
      if (this.value) {
        date = new Date(this.value)
      }
      this.$emit('changed', { value: date, id: this.id })
    },
    getState: function () {
      if (this.required && !this.value) {
        return false
      }
      return this.state
    }
  },
  watch: {
    vModel() {
      this.value = this.vModel
    }
  }
}
</script>
